<div class="loader-container" *ngIf="isLoadingResults">
  <mat-spinner></mat-spinner>
</div>
<ng-container *ngIf="!isLoadingResults">
  <div>
    <mat-table [dataSource]="subdatasetCollections" style="width:100%" class="mat-elevation-z8">
      <ng-container matColumnDef="product_name">
        <mat-cell *matCellDef="let subproducts" class="center">
          <a class="cursor-pointer" [href]="subproducts.psg_webtag_url" target="_blank" rel="noopener noreferrer">
            {{ subproducts.product_name }}
          </a>
        </mat-cell>
      </ng-container>
      <mat-row *matRowDef="let row; columns: ['product_name']"></mat-row>
    </mat-table>
  </div>
</ng-container>

